export default function talkToUsCtrl($scope) {
    $scope.validationOptions = {
        rules: {
            talk_email: {
                required: true,
                email: true
            }
        },
        messages: {
            talk_email: {
                required: "We need your email address to contact you",
                email: "Your email address must be in the format of name@domain.com"
            }
        },
        ignore: [],
        errorPlacement: function (error, element) {
            error.insertAfter(element);
        },
        highlight: function (element, errorClass, validClass) {
            if ($(element).is(":hidden")) {
                $(element)
                    .addClass(errorClass)
                    .removeClass(validClass);
            } else {
                $(element)
                    .addClass(errorClass)
                    .removeClass(validClass);
            }
        },
        unhighlight: function (element, errorClass, validClass) {
            if ($(element).is(":hidden")) {
                $(element)
                    .removeClass(errorClass)
                    .addClass(validClass);
            } else {
                $(element)
                    .removeClass(errorClass)
                    .addClass(validClass);
            }
        }
    };

    $scope.fancyboxOptions = {
        toolbar: false,
        smallBtn: true,
        clickOutside: false,
        trapFocus: false,
        touch: {
            vertical: false,
            momentum: false
        },
        btnTpl: {
            smallBtn: '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="Close">' +
                '<i class="icon-close icon-l"></i>' +
                "</button>"
        },
        beforeLoad: function (instance, slide) {
            if (instance.$lastFocus[0].attributes["data-fancybox-class"]) {
                $(instance.$refs.container[0]).addClass(
                    instance.$lastFocus[0].attributes["data-fancybox-class"].value
                );
            }
        }
    };

    $scope.talkToUs2 = function () {
        alert('asas');
    }

    $scope.talkToUsForm = function () {
        $.fancybox.open({
            src: "#modal-talk",
            type: "inline",
            opts: $scope.fancyboxOptions
        });
    };
    $scope.messageSent = false;
    $scope.talkToUs = function () {

        var isvalid = $scope.talkToUsForm.validate();
        var formData = {};

        formData.action = "send-contact";
        formData.name = $('#form-talk-to-us input[name="talk_name"]').val();
        formData.email = $('#form-talk-to-us input[name="talk_email"]').val();
        formData.subject = $('#form-talk-to-us input[name="talk_subject"]').val();
        formData.message = $('#form-talk-to-us textarea[name="talk_message"]').val();

        if (isvalid) {
            $('#form-talk-to-us button').toggleClass('loading');
            $('#form-talk-to-us  :input').prop("disabled", true);
            // $http({
            //     method: "POST",
            //     url: "/actions.php",
            //     data: $rootScope.params(formData),
            //     headers: {
            //         "Content-Type": "application/x-www-form-urlencoded"
            //     } // set the headers so angular passing info as form data (not request payload)
            // }).then(function (data) {
            //     $scope.messageSent = data.status;
            //     if (!data.status) {

            //     } else {
            //         $('#form-talk-to-us input[name="talk_name"]').val('');
            //         $('#form-talk-to-us input[name="talk_email"]').val('');
            //         $('#form-talk-to-us input[name="talk_subject"]').val('');
            //         $('#form-talk-to-us textarea[name="talk_message"]').val('');
            //     }
            //     $('#form-talk-to-us :input').prop("disabled", false);
            //     $('#form-talk-to-us button').toggleClass('loading');
            // });
        }

    };
}

talkToUsCtrl.$inject = ['$scope'];